module.exports = __webpack_public_path__ + "static/media/default.9dbd6676.jpg";